export const LOCATION_CHANGE = 'app/router/LOCATION_CHANGE';

export const locationChange = (location, navigationType) => ({
  type: LOCATION_CHANGE,
  payload: { location, action: navigationType },
});
